import { createAction, props } from '@ngrx/store';
import { User } from '../user.entity';

export const upsertUserSuccess = createAction(
  '[User API] Upsert User Success',
  props<{ user: User; id: number | null }>()
);

export const upsertUserFail = createAction('[User API] Upsert User Fail');
